import React from 'react';
import Seo from '../components/Seo';
import Hero from '../components/Hero';
import Work from '../components/Work';
import Services from '../components/Services';
import WhyUs from '../components/WhyUs';
import ProjectArchive from '../components/ProjectArchive';
import Testimonials from '../components/Testimonials';
import About from '../components/About';

const Home = () => {
    return (
        <main>
            <Seo /> 
            <Hero />
            <Work />
            <About />
            <Services />
            <WhyUs />
            <ProjectArchive />
            <Testimonials />
        </main>
    );
};

export default Home;